export default "__VITE_ASSET__BkvpCntJ__"